'use strict';

var paymentModule = angular.module('t2g.payment', [
  'ui.router',
  require('t2g.common.data-access.payment').name,
  require('t2g.common.services.userSessionService').name,
]);

module.exports = paymentModule;

paymentModule.controller('PaymentsController', require('./PaymentsCtrl'));

paymentModule.config(function($stateProvider) {
  $stateProvider.state('private.main.payments', {
    url: '/payments',
    title: 'Payments',
    templateUrl: '/app/modules/payment/PaymentsView.html?v=4.5.6',
    controller: 'PaymentsController as PaymentsController',
    resolve: {
      paymentsResolve: function(PaymentDA) {
        return PaymentDA.getAll();
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/payment/paymentModule.js